var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.25 2.045A6.405 6.405 0 0 0 4.223 12.68L7.5 16.317a2.025 2.025 0 0 0 3 0l3.262-3.637A6.412 6.412 0 0 0 8.25 2.045M9 10.813a2.408 2.408 0 1 1-.015-4.816A2.408 2.408 0 0 1 9 10.813",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 10.88a2.535 2.535 0 1 0 0-5.07 2.535 2.535 0 0 0 0 5.07"
  })));
};
export default SvgPin;